import { TState } from 'redux/store'

export const languageSelector = (state: TState): string => state.language.currentLanguage
